export enum COOKIES {
  PRODUCT_COOKIE_TOKEN = 'investor-token',
  PRODUCT_COOKIE_COMPANY_ID = 'company-id',

  __SESSION = '__session'
}
